export enum Channel {
    NONE = '',
    ONLINE = 'ONLINE',
    BM = 'B&M',
}
